import React from "react";

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {" "}
            <img
              src="img/team/GiroTeam.png"
              className="img-responsive"
              alt=""
            />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>sobre nosotros</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
              <h3>Equipo</h3>
              <p>
                Creemos firmemente que las personas juegan un rol fundamental a
                la hora de poder brindar un servicio de excelencia, por lo cual,
                nos preocupamos en consolidar un gran equipo de personas,
                altamente capacitado y comprometidos con cada uno de nuestos
                clientes.
              </p>
              <h3>Calidad</h3>
              <p>
                Nos preocupamos de trabajar con lo más altos estándares durante
                todo el ciclo del desarrollo de nuestras soluciones, en sus
                inicios, utilizando metodologías de ingeniería y desarrollo de
                sofftware que garantiza escalabilidad, seguridad y alta
                disponibilidad, seguido por estrategias de experiencia usuaro,
                permitiendo una rápida e intuitiva adopción y finalmente
                rigurosos procesos de mantención y soporte.
              </p>
              <h3>Innovación</h3>
              <p>
                Estamos concientes de que una propuesta relamente innovadora
                nace del profundo entendimiento de las verdaderas necesidades de
                nuestros clientes, lo cual nos obliga a mirar fuera de la caja y
                diseñar soluciones únicas, en comparacion a lo ofrecido en el
                mercado, con un importante grado de personalización y
                felixibilidad.
              </p>
              {/* <h3>Why Choose Us?</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}> {d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
